import service from '../api/service'
import Vue from 'vue'

var jweixin = require('jweixin-module');
console.warn('jweixin')

export default {
	toast:Vue.prototype.$toast,
	//判断是否在微信中
	isWechat: function () {
		var ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/micromessenger/i) == 'micromessenger') {
			console.log('是微信客户端')
			return true;
		} else {
			console.log('不是微信客户端')
			return false;
		}
	},
	//初始化小程序启动配置
	initConfig: function (sucCB, errCB) {
		service.post("/params/JSSDKSignature", {}, true).then(res => {
			if (res.data) {
				jweixin.config({
					beta: true,
					debug: false,
					appId: res.data.appId,
					timestamp: res.data.timestamp,
					nonceStr: res.data.nonceStr,
					signature: res.data.signature,
					jsApiList: [
						'checkJsApi',
						// 'onMenuShareTimeline',
						// 'onMenuShareAppMessage'
						'updateTimelineShareData',
						'updateAppMessageShareData'
					],
					openTagList: [
						'wx-open-launch-weapp'
					]
				});

				let err = false

				jweixin.error(function (res) {
					err = true
					// console.error("jssdk config error",that.toast);
					that.toast.fail('jssdk config error');
					if (errCB) errCB()
				});

				// 失败了也会调这个
				jweixin.ready(function (res) {
					if (err) err = false
					else {
						if (sucCB)
						{
							sucCB()
						} 
						console.warn("jssdk config ready");
					}
				});
			}
		})
	},
	//在需要自定义分享的页面中调用
	share: function (data) {
		let that = this

		if (!that.isWechat()) {
			return;
		}

		let url = window.location.href;
		if (data.row) {
			url += `&row=${encodeURIComponent(JSON.stringify(data.row))}`
			console.info(url)
		}

		that.initConfig(() => {
			var shareData = {
				title: data && data.title ? data.title : '',
				desc: data && data.desc ? data.desc : '',
				link: url,
				imgUrl: data && data.imgUrl ? service.baseURLB + data.imgUrl : '',
				success: (e) => {
					// that.toast('分享成功');
				},
				cancel: () => {
					// that.toast('您已取消分享');
				}
			};

			// that.toast('请通过右上角进行分享');

			jweixin.updateTimelineShareData(shareData)
			jweixin.updateAppMessageShareData(shareData)

			// jweixin.onMenuShareAppMessage(shareData)
			// jweixin.onMenuShareTimeline(shareData);
		})
	},
}
